module.exports = __webpack_public_path__ + "img/login.b0ee55de.svg";